interface DataType {
  uuid: string;
  [key: string]: string | number | boolean | string[] | number[];
}

const filterRecordById = (data: DataType[], id: string) =>
  data?.find((record) => record.uuid === id || record.key === id);

export { filterRecordById };
